import React from "react"
import { useScrollAnim } from "src/components/hooks/hooks"


export const ProjectDetailsInfrastructure = ({ data }) => {
    const [trigger, anim] = useScrollAnim()

    return (
        <>
            {data.buttons && (
                <section className="py-main bg-light sc-project-infrastructure" ref={trigger}>
                    <div className="container">
                        <h2 className={`mb-4 ${anim(1)}`}>{data.title}</h2>
                        <div className="row">
                            {data?.buttons?.map((infra, i) => {
                                return (
                                    <div className={`col-md-4 mb-4 ${anim(2 + i)}`} mb-4 key={i}>
                                        <div className="d-flex align-items-center">
                                            <img src={infra?.icon?.sourceUrl} className="img-fluid h-50px" alt="icon" />
                                            <p className="ml-4 mb-0 text-infrastructure">{infra.text}</p>
                                        </div>
                                        {/* <div className="row">
                                            <div className="col-3 col-md-4 col-lg-3 col-xl-2">
                                                <img src={infra?.icon?.sourceUrl} className="img-fluid h-50px" alt="icon" />
                                            </div>
                                            <div className="col-9 col-md-8 col-lg-9 col-xl-10 d-flex align-items-center">
                                                <p className="mb-0 text-infrastructure">{infra.text}</p>
                                            </div>
                                        </div> */}
                                    </div>
                                )
                            })}
                        </div>
                    </div>
                </section>
            )}
        </>
    )
}